<template>
  <el-dialog
    title="修改风资源名称"
    :visible="visible"
    width="20%"
    :before-close="handleCancel"
  >
    <span
      ><el-input v-model="itemName" placeholder="请输入风资源名称"></el-input>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updateItemName } from '../service';
import to from 'await-to-js';
export default {
  props: {
    visible: {
      type: Boolean,
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      itemName: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.itemName = this.item?.itemName;
    });
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
    async handleSubmit() {
      if (!this.itemName) return;
      const [err, result] = await to(
        updateItemName({
          itemId: this.item?.itemId,
          itemName: this.itemName,
        })
      );
      console.log(result)
      if (!err && result.code === 0) {
        this.$message.success(result.message || '操作成功');
        this.handleCancel();
        this.$emit('saveBack')
      }
    },
  },
};
</script>
